import React from "react";

import { Helmet } from "react-helmet";
import { Container } from "react-bootstrap";
import Header from "components/layout/Header";
import { useTranslation } from "react-i18next";
import { blobURL } from "common/StringUtils";

const CoolCompanyVsInvozio = () => {
  const comparison1 = `${blobURL}/comparison-1.jpg`;

  const { t } = useTranslation();

  return (
    <div className="network-page">
      <Helmet>
        <title> {t("Clear winner: Invozio vs Frilans Finans")} </title>
        <meta
          name="description"
          content={t("With Invozio, you'll have three times as much in your wallet compared to Frilans Finans. Invozio is simpler and more cost-effective than Frilans Finans. Try us now!")}
        />
        <meta name="keywords" content="frilans finans"></meta>
      </Helmet>

      <Header />

      <div className="p-0 self_new negotiate network-page mb-0 nw_add_scc busniness_new">
        <div className="negotiation_wrap new_desgn_insurance inspiration fakt new_margin_header px-0 p-0">
          <Container className="self_new responsive_self">
            <div className="seo_pages">
              <section className="insurns_wrap self-empoyee">
                <div className="container">
                  <div className="row align-items-center p-2">
                    <div className="col-lg-6">
                      <div className="slf_text">
                        <h1 className="security_about text-uppercase mb-0">
                          Frilans Finans vs Invozio
                        </h1>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="text-right">
                        <img
                          src={comparison1}
                          alt="frilans finans"
                          className="img-fluid"
                          style={{
                            borderRadius: "20px",
                            width: "380px",
                            height: "320px",
                            padding: "12px",
                          }}
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section className="newdesign">
                <div className="container p-0">
                  <div className="without_background">
                    <h1 className="heading_edit">Frilans Finans</h1>
                    <div className="new_text">
                      <p>
                        {" "}
                        {t(
                          "Frilans Finans is a leading player in Sweden for individuals who want to work independently. They offer a platform for flexible invoicing without their own company, management of taxes, customer support, management of ROT and RUT, deduction possibilities, international invoicing, collective agreements and comprehensive insurance solutions. They started already in 1999, which makes them the oldest in the industry."
                        )}
                      </p>
                    </div>
                    <div className="new_text">
                      <h3 className="mb-2 accident_ins">
                        {t("Overall comparison Frilans Finans and Invozio")}
                      </h3>
                      <p>
                        {t(
                          "Invozio is also a platform that allows freelancers, small businesses and consultants to send invoices without starting their own business. Just like Cool Company, they manage taxes, fees and administration for their customers. Invozio is known for its speed and simplicity when it comes to sending invoices, and they offer a variety of features to make it easier for freelancers and small businesses to manage their invoicing."
                        )}
                      </p>
                    </div>
                    <div className="new_text">
                      <h3 className="mb-2 accident_ins">
                        {t(
                          "A question of priorities - the old established or against the new fast-paced"
                        )}
                      </h3>
                      <p>
                        {" "}
                        {t(
                          "Invozio and Frilans Finans stand out as prominent players in the market when it comes to offering services such as invoicing and finance for freelancers and small businesses. Their services aim to relieve these professional groups from the administrative, legal and financial burdens such as bookkeeping that traditionally come with running a business as well as being able to work as self-employed. By significantly reducing the time spent on paperwork and tax management, these platforms enable their clients to focus their energy and time on core business. While both companies operate in the same niche, there are distinct differences in offering, user interface, features and pricing. This means that depending on an individual or company's specific needs and priorities, one platform may be more suitable than the other."
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="with_background">
                    <div className="new_text">
                      <h2 className="mb-2 accident_ins">
                        {t(
                          "From whom do you get the most money from Cool Company - Invozio or Freelance Finance?"
                        )}
                      </h2>
                      <p>
                        {t(
                          "Let's take a look at how much a freelancer would earn when billing 10,000 SEK through each platform, based on the information on their websites."
                        )}
                      </p>
                    </div>
                    <div className="new_text">
                      <h3 className="mb-2 accident_ins">Invozio</h3>
                      <p>
                        {t(
                          "With Invozio, the fee is 1.9%. So if you invoice SEK 10,000, the fee would be SEK 190. The freelancer thus receives SEK 9,810."
                        )}
                      </p>
                    </div>
                    <div className="new_text">
                      <h3 className="mb-2 accident_ins"> Frilans Finans</h3>
                      <p>
                        {t(
                          "Frilans Finans charges a fee of 6%. So if you invoice SEK 10,000, the fee would be SEK 600. The freelancer thus receives SEK 9,400. Based on these figures and without taking into account any additional services or benefits that may be offered by each platform, it would seem that the freelancer gets more money per invoiced kroner through Invozio compared to Frilans Finans. So if you want more in your wallet every month, you should turn to Invozio."
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default CoolCompanyVsInvozio;
